import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { Table } from "antd";

const HouseInventory = () => {
    const routes = all_routes;

    const data = [
        {
            key: "1",
            houseNo: "A-101",
            type: "Type-A",
            block: "Block A",
            status: "Occupied",
            maintenance: "Civil Done",
        },
        {
            key: "2",
            houseNo: "B-202",
            type: "Type-B",
            block: "Block B",
            status: "Vacant",
            maintenance: "E&M Pending",
        },
        {
            key: "3",
            houseNo: "C-303",
            type: "Type-C",
            block: "Block C",
            status: "Vacation Initiated",
            maintenance: "Inspection Required",
        },
    ];

    const columns = [
        {
            title: "House No",
            dataIndex: "houseNo",
            sorter: (a: any, b: any) => a.houseNo.localeCompare(b.houseNo),
        },
        {
            title: "Type",
            dataIndex: "type",
            sorter: (a: any, b: any) => a.type.localeCompare(b.type),
        },
        {
            title: "Block",
            dataIndex: "block",
            sorter: (a: any, b: any) => a.block.localeCompare(b.block),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string) => {
                let color = "badge-success";
                if (text === "Occupied") color = "badge-danger";
                if (text === "Vacation Initiated") color = "badge-warning";
                if (text === "Vacant") color = "badge-info";
                return <span className={`badge ${color}`}>{text}</span>;
            },
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        },
        {
            title: "Maintenance",
            dataIndex: "maintenance",
            render: (text: string) => (
                <span className={`small ${text.includes('Pending') ? 'text-danger fw-bold' : 'text-muted'}`}>
                    <i className="ti ti-tool me-1"></i> {text}
                </span>
            )
        },
        {
            title: "Action",
            render: () => (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary" title="Edit House"><i className="ti ti-edit"></i></button>
                    <button className="btn btn-sm btn-outline-info" title="Maintenance Log"><i className="ti ti-history"></i></button>
                </div>
            ),
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">House Inventory</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={routes.staffQuarterAdmin.dashboard}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Inventory</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn btn-primary">
                                <i className="fa fa-plus"></i> Add House
                            </Link>
                        </div>
                    </div>
                </div>
                {/* /Page Header */}

                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={data}
                                rowKey={(record) => record.key}
                                pagination={{
                                    total: data.length,
                                    showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                    showSizeChanger: true,
                                    onShowSizeChange: (current, pageSize) => { },
                                    itemRender: (current, type, originalElement) => {
                                        return originalElement
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HouseInventory;
